import AuthLayout from '../../components/auth/AuthLayout'

const authRoutes = [
  {
    path: '/auth',
    component: AuthLayout,
    redirect: { name: 'login' },
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../../components/auth/login/Login')
      },
      {
        name: 'account',
        path: 'account',
        component: () => import('../../components/auth/login/Account')
      },
      {
        name: 'forget-password',
        path: 'forget-password',
        component: () =>
          import('../../components/auth/forget-password/forget-password')
      },
      {
        name: 'pin',
        path: 'pin',
        component: () => import('../../components/auth/forget-password/pin')
      },
      {
        name: 'reset-password',
        path: 'reset-password/:token',
        component: () =>
          import('../../components/auth/forget-password/reset-password')
      },
      {
        name: 'demo-register',
        path: 'demo/register',
        component: () => import('../../components/auth/demo/DemoRegister')
      }
    ]
  },
  {
    // Top-level `/activate` to match the invitation link (USER_ACTIVATION_LINK)
    // and the new portal's URL pattern. Wrapped in AuthLayout for the shared
    // auth styling. Token is read from the query string (?token=) or an optional
    // path param.
    path: '/activate',
    component: AuthLayout,
    children: [
      {
        name: 'activate-account',
        path: ':token?',
        component: () =>
          import('../../components/auth/forget-password/activate-account')
      }
    ]
  }
]

export default authRoutes
